import { AppConstantsInterface } from '@plugin/Common/interfaces/cross-sell/app-constants.interface'

const appConstants: AppConstantsInterface = {
  productImageThumbnailSize: 160,
  sessionStorageKey: 'aspenwareCrossSell',
}

export { appConstants }
